"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_DATABASE_COLUMN_TYPES = void 0;
exports.isAppDatabaseColumnType = isAppDatabaseColumnType;
exports.unsupportedAppDatabaseColumnTypeMessage = unsupportedAppDatabaseColumnTypeMessage;
/**
 * Column types a portable App table may declare. The App package form and the
 * marketplace template contract both read this list, so a column type is
 * accepted or refused the same way on both paths.
 */
exports.APP_DATABASE_COLUMN_TYPES = [
    'attachment',
    'checkbox',
    'date',
    'link',
    'member',
    'multi-select',
    'number',
    'progress',
    'relation',
    'rich-text',
    'rollup',
    'select',
    'title',
];
const COLUMN_TYPES = new Set(exports.APP_DATABASE_COLUMN_TYPES);
/** Names authors reach for that are no column type, with the type to use. */
const COLUMN_TYPE_HINTS = {
    text: 'use "rich-text".',
    url: 'use "link".',
    email: 'use "rich-text" or "link".',
    image: 'photos belong in an "attachment" column; acceptedMimeTypes of its upload command limits it to images.',
};
function isAppDatabaseColumnType(type) {
    return COLUMN_TYPES.has(type);
}
/** The one sentence both checks answer with for a refused column type. */
function unsupportedAppDatabaseColumnTypeMessage(type) {
    const hint = Object.prototype.hasOwnProperty.call(COLUMN_TYPE_HINTS, type)
        ? COLUMN_TYPE_HINTS[type]
        : undefined;
    return hint
        ? `Database column type "${type}" is not supported; ${hint}`
        : `Database column type "${type}" is not supported.`;
}
